import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {RecipientsFormatter} from '../../../../../../srcCommon/formatters/recipientsFormatter';
import {VisualRecipientModel} from '../../../../../models/api/visualRecipientModel';

/*
 * Props.
 */

interface CellRecipientsProps {
  recipients: ReadonlyArray<VisualRecipientModel>;
  isSelected?: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  grid-area: top-line;
  display: flex;
  align-items: center;
  min-width: 0;
`;

interface CellRecipientsStyleProps {
  $isSelected?: boolean;
}
const StyledRecipientsDiv = styled.div<CellRecipientsStyleProps>`
  flex-shrink: 2;
  font-weight: ${fontWeights.semibold};
  color: ${(p) => (p.$isSelected ? p.theme.greys.white : p.theme.greys.shade90)};

  ${ellipsis()};
`;

const StyledEmptySpan = styled.span`
  font-style: italic;
`;

/*
 * Component.
 */

export const CellRecipients: FC<CellRecipientsProps> = (props) => (
  <StyledWrapperDiv>
    <StyledRecipientsDiv $isSelected={props.isSelected}>
      {renderRecipients(props.recipients)}
    </StyledRecipientsDiv>
  </StyledWrapperDiv>
);

function renderRecipients(recipients: ReadonlyArray<VisualRecipientModel>) {
  // If we have no recipients, display a message.
  if (recipients.length === 0) {
    return (
      <StyledEmptySpan>
        <Trans id="draft-no-recipients">No recipients</Trans>
      </StyledEmptySpan>
    );
  }

  return <RecipientsFormatter recipients={recipients} />;
}
